/**=========================================================
 * Module: app-actions.js
 * Handles actions menu
 =========================================================*/

App.directive('appActions', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/actions.html',
      restrict: 'E',
      replace: true
  };

});
